import React, { useEffect, useState } from "react";
/**
 * The frame of the byttevagt pages (the boards "Byttevagt - ..." and "Byt med mig"): a back link to
 * the list, the title and the content.
 *
 * On a phone the board replaces the top bar with a bar that only holds the back link, so while one
 * of these pages is up `bi-subpage` sits on the body and the stylesheet hides the top bar below lg.
 * From lg up the back link stands above the title instead, under the usual top bar.
 */
export const BYTTEVAGTER_URL = "/byttevagter/";
const BackLink = () => (React.createElement("a", { className: "bi-bv-back", href: BYTTEVAGTER_URL },
    React.createElement("i", { className: "fa-solid fa-chevron-left", "aria-hidden": "true" }),
    "Byttevagter"));
export const BvPage = ({ title, className, children }) => {
    useEffect(() => {
        document.body.classList.add("bi-subpage");
        return () => document.body.classList.remove("bi-subpage");
    }, []);
    return (React.createElement("div", { className: `bi-bv${className ? ` ${className}` : ""}` },
        React.createElement("div", { className: "bi-bv-backbar" },
            React.createElement(BackLink, null)),
        React.createElement("div", { className: "bi-bv-body" },
            React.createElement("div", { className: "bi-bv-back-wide" },
                React.createElement(BackLink, null)),
            React.createElement("h1", { className: "bi-bv-title" }, title),
            children)));
};
/** The card the states of a byttevagt are told in. */
export const BvCard = ({ title, children }) => (React.createElement("div", { className: "bi-bv-card-wrap" },
    React.createElement("div", { className: "bi-bv-card" },
        React.createElement("h2", null, title),
        children)));
/** The link a byttevagt is shared by, which is what the owner copies. */
export const exchangeUrl = (slug) => `${window.location.origin}/byttevagt/?slug=${slug}`;
/**
 * "Kopiér link" as a button that says what happened: the label turns into "Kopieret" for a moment, or
 * "Kunne ikke kopiere" when the browser refuses.
 */
export const CopyLinkButton = ({ slug, className, icon }) => {
    const [copied, setCopied] = useState(null);
    const copy = () => {
        navigator.clipboard.writeText(exchangeUrl(slug))
            .then(() => setCopied("ok"))
            .catch(() => setCopied("failed"))
            .finally(() => window.setTimeout(() => setCopied(null), 2500));
    };
    return (React.createElement("button", { type: "button", className: className, onClick: copy },
        icon,
        copied === "ok" ? "Kopieret" : copied === "failed" ? "Kunne ikke kopiere" : "Kopiér link"));
};
